import axios from 'axios';
import FitCultural from '../entity/fit-cultural.entity';

export default class FitCulturalService {
  public static send(surveyAnswers: FitCultural) {
    return axios.post('/api/public/fit-cultural', surveyAnswers);
  }
}
